// Copyright 2025, University of Maryland, All Rights Reserved
export interface SchedulerRecord {
  pk: string;
  sk: string;
  job_name: string;
  org?: string | null;
  ws?: string | null;
  scope?: string | null;
  cadence: string;
  last_run?: string | null;
  args?: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export interface CreateSchedulerRequest {
  job_name: string;
  cadence: string;
  org?: string | null;
  ws?: string | null;
  scope?: string | null;
  args?: Record<string, unknown> | null;
}

export interface UpdateSchedulerRequest {
  cadence?: string;
  args?: Record<string, unknown> | null;
}

// Prefix for a daily cadence pinned to a time of day, e.g. "daily@14:30" (US/Eastern).
export const DAILY_TIME_PREFIX = 'daily@';

export const CADENCE_OPTIONS = [
  { value: 'minutely', label: 'Every Minute' },
  { value: 'every_5_minutes', label: 'Every 5 Minutes' },
  { value: 'every_15_minutes', label: 'Every 15 Minutes' },
  { value: 'every_30_minutes', label: 'Every 30 Minutes' },
  { value: 'hourly', label: 'Every Hour' },
  { value: 'every_6_hours', label: 'Every 6 Hours' },
  { value: 'every_12_hours', label: 'Every 12 Hours' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
] as const;
